// extracted by mini-css-extract-plugin
export default {"panel":"xWyA","content":"Grg3","status-container":"qopE","statusContainer":"qopE"};